import React, { Component } from 'react';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { StyleSheet, css } from 'aphrodite/no-important';
import queryString from 'query-string';
import Actions from '../../../../Actions';
import RowShallow from './Level_1/RowShallow';
import RowDeep from './Level_2/RowDeep';
import Tile from '../../Layout/Tile';


class List extends Component {

    componentDidMount = () => {
        const { auth, getJobs, hash } = this.props;
        const urlQuery = queryString.parse(hash);
        getJobs(auth.token, {page: 1,per_page: '250', sort: 'vanity_id', order: 'desc' ,status: [1,2,3,4], ...urlQuery }, false);
    }

    componentDidUpdate = (prevProps) => {
        const { hash: newHash } = this.props;
        const { hash: oldHash } = prevProps;
        if(newHash !== oldHash){
            const { auth, getJobs } = this.props;
            const query = queryString.parse(newHash);
            getJobs(auth.token, { page: 1, per_page: '250' ,sort: 'vanity_id', order: 'desc' ,...query }, false);
        }
    }

    jobsLoading = () => {
        const data = [];
        const { jobCol } = styles;

        for(let i=0;i<10;i++){
            data.push(
                <Tile xs="12" key={i} className={`mx-auto ${css(jobCol)}`}>
                    <Skeleton count={4}/>
                </Tile>
            );
        }

        return data;
    }

    jobs = () => {
        const { jobs, jobsMeta, level } = this.props;
        const data = [];
        jobsMeta.data.map((id) => {
            data.push(
                level === "1" ? <RowShallow key={id} job={jobs[id]}/>: <RowDeep key={id} job={jobs[id]}/>
            );
        });
        return data;
    }

    render(){
        const { jobsLoading } = this.props;
        return (
            <div className="p-3">        
                {jobsLoading ? this.jobsLoading(): this.jobs()}
            </div>            
        );
    }
}

const styles = StyleSheet.create({
    jobCol: {
        padding: "1vh 1vw",
    }
});

const mapStateToProps = (state) => ({
    auth: state.auth,
    jobs: state.jobStore.jobs,
    jobsMeta: state.jobStore.jobsMeta,
    query: state.jobStore.query,
    jobsLoading: state.jobStore.jobsLoading,
});

export default connect(mapStateToProps,Actions.jobs)(List);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/Handyman/List.js